module.exports = __webpack_public_path__ + "img/american-express.23138710.png";